<template>
  <div class="social-share-container">
    <template v-if="showBtn">
      <div class="buttons">
        <a class="shareBtn" @click="copyLink" :class="{clicked: isShareActive}">
          <img
            data-aos="fade-up"
            data-aos-delay="100" 
            :src="require(`@img/socialShare/btn_share_${locale}.png`)"
            alt="shareBtn"
          >
        </a>
      </div>
    </template>
    <div data-aos="fade-up">
      <img @click="toDownloadPage" class="qrcode" :src="require('@img/socialShare/qrcode.jpg')" alt="qrcode">
      <img class="legal_line" :src="require('@img/socialShare/legal_line.png')" alt="legal_line">
    </div>
  </div>
</template>

<script setup>
import { defineProps, ref, onMounted } from "vue";
import { Toast } from "vant";
import { locale, t } from "../locales";
import { checkIpLegal } from "@/api/official";


const props = defineProps({
  showBtn: {
    type: Boolean,
    default: true
  },
  params: {
    type: Object
  },
  loginTime: {
    type: String
  }
});
const licence = ref(0)
let isShareActive = ref(false)

const callApi = async () => {
  const result = await checkIpLegal()
  licence.value = result.legal
}


function copyLink() {
  isShareActive.value = !isShareActive.value
  setTimeout(() => {
    isShareActive.value = !isShareActive.value
  }, 200)
  const link = location.href.replace("&inkkwebview=true", "");

  // copy link
  if (navigator.clipboard) {
    navigator.clipboard.writeText(link);
  } else {
    fallbackCopy(link);
  }

  Toast(t("toast.linkCopied"));
}

function fallbackCopy(text) {
  const textarea = document.createElement('textarea');
  textarea.value = text;
  
  // 关键：设置为只读，防止键盘弹出
  textarea.readOnly = true;
  
  // 设置样式确保不影响布局
  textarea.style.cssText = `
    position: fixed;
    top: -9999px;
    left: -9999px;
    width: 1px;
    height: 1px;
    opacity: 0;
    pointer-events: none;
    z-index: -9999;
    -webkit-user-select: all;
    user-select: all;
  `;
  
  document.body.appendChild(textarea);
  
  try {
    textarea.setSelectionRange(0, textarea.value.length);
    const successful = document.execCommand("copy");
    
    if (!successful) {
      Toast('textarea copy failed');
    }
  } catch(err) {
    Toast('textarea copy error: ' + err);
  } finally {
    // 清理
    if (document.body.contains(textarea)) {
      document.body.removeChild(textarea);
    }
  }
}

async function toDownloadPage() {
  const u = navigator.userAgent;
  const isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1;
  const isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
  const licence = await checkIpLegal()

  const countyMap = {
    pt: "br",
    jp: "jp",
    mn: "mn",
    es: "es",
  }[locale.value];
  const subDomain = licence.value !== 4 ? (countyMap || "www") : (countyMap || "en")
  let link =
    licence.value !== 4 
    ? subDomain === "mn"
      ? "https://kkmon.net/downloadpage/"
      : `https://${subDomain}.kkpoker.net/downloadpage`
    : `https://kkpoker.co/${subDomain === 'br' ? 'pt' : subDomain}/downloadpage`
  
  if (process.env.VUE_APP_PROJECT_NAME ==='NUTS') {
    link = 'https://nutspoker.cc/downloadpage'
  }

  if (isAndroid || isIOS) {
    window.location.href = link;
  } else {
    window.open(link, "_blank");
  }
}


onMounted(() => {
  callApi()
})

</script>
<style lang="scss" scoped>
.social-share-container {
  position: relative;
  text-align: center;
  margin-top: 20%;
  margin-bottom: 20%;
}

img {
  cursor: pointer;
  width: 55%;
}

.shareBtn {
  display:flex;
  justify-content: center;
  margin-bottom: 30px;
  @media (max-width: $containerWidth) {
    margin-bottom: pxToVw(30px);
  }

  &.clicked img {
    transform: scale(0.90);
    transition: transform 0.1s ease;
  }
}
.save {
  display:flex;
  justify-content: center;
  margin-bottom: 60px;
  @media (max-width: $containerWidth) {
    margin-bottom: pxToVw(60px);
  }

  &.clicked img {
    transform: scale(0.90);
    transition: transform 0.1s ease;
  }
}

.qrcode {
  margin: 30px;
  // cursor: pointer;
  width: 284px;
  animation: shinning 2s ease-in-out infinite;

  @media (max-width: $containerWidth) {
    width: pxToVw(284px);
  }
}

.legal_line {
  width: 519px;
  cursor: auto;

  @media (max-width: $containerWidth) {
    width: pxToVw(519px);
  }
}

</style>
